import React, {useState, useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import SelectOptionButton from '../../../../Shared/SelectOptionButton/SelectOptionButton';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {
  resetState,
  setSimCardType,
  setSelectedTransferOption,
  setHasSimCard,
  getOrganizationBanNumbers,
  getPhoneNumbers,
  setCurrentStep,
  getPriceSim,
  setCurrentPopUp,
  setNumberForNuid,
  niudNumberValidation,
  setEpiData,
  setSelectedBanNumber,
  GetOrganizationPricePlan,
} from '../../TransferOrganizationAccountSlice';
import {simCardType, transferOption, TransferAccountStep, PopupEnum} from '../../Constant/Constant';
import SelectBanNumberComponent from './SelectBanNumberComponent';
import SelectSimTypeComponent from './SelectSimTypeComponent';
import SelectTransferLineComponent from './SelectTransferLineComponent';
import NiudNumberComponent from './NiudNumberComponent';
import SimNumberComponent from './SimNumberComponent';
import SelectPhoneNumber from './SelectPhoneNumber';
import SimCountComponent from './SimCountComponent';
import {dwhStepOneContinueButtonReport} from '../../Reports/dwhReports';
import SimActionBtns from '../../Popups/SimActionBtns';

function TransferLine(props) {
  const hasSimCardButtons = [
    {id: '0', label: 'כן', value: true, selected: props.data.hasSimCard === true ? true : false},
    {id: '1', label: 'לא', value: false, selected: props.data.hasSimCard === false ? true : false},
  ];
  const [showBanNumbersList, setShowBanNumbersList] = useState(false);
  const [error, setError] = useState('');

  async function manageHasSimCard(value) {
    if (props.data.hasSimCard != value) {
      //set hasSimCard in redux store and remove all data that was entered before
      const currentEpiData = props.data.epiData;
      props.resetState();
      props.setEpiData(currentEpiData);
      setShowBanNumbersList(false);
      if (value === false) {
        await props.getPriceSim();
      }

      props.setHasSimCard(value);
    }
  }

  useEffect(() => {
    if (props.data.banListForSelect.length > 0 && props.data.banListForSelect.length != 1) {
      setShowBanNumbersList(true);
    }
  }, [props.data.banListForSelect]);

  useEffect(() => {
    if (props.data.simCardNumberAccepted || props.data.simCardType == simCardType.eSim) {
      props.getOrganizationBanNumbers(props.portalsBlock.selectedHetPay);
    }
    if (props.data.hasSimCard === true && props.data.simCardType === simCardType.sim) {
      if (!props.data.simCardNumberAccepted) {
        setShowBanNumbersList(false);
        props.setSelectedBanNumber('');
        props.setSelectedTransferOption(transferOption.undefined);
      }
    }
  }, [props.data.simCardNumberAccepted, props.data.simCardType]);

  useEffect(() => {
    if (props.data.selectedTransferOption == transferOption.newLine && props.data.phoneNumbersForSelect.length == 0) {
      props.getPhoneNumbers();
    }
  }, [props.data.selectedTransferOption]);

  function deviceSupportsEsimCheckBox() {
    if (props.data.deviceSupportsEsim) {
      return true;
    }
    props.setCurrentPopUp(PopupEnum.DeviceSupportsESIMCheckBox);
    focusOnSupportsEsim();
    return false;
  }

  function validateNumberForNiud() {
    let phoneRegex = /^0?(([23489]{1}\d{7})|[57]{1}\d{8})$/;
    let error = '';
    if (!phoneRegex.test(props.data.numberForNiudForm.value?.trim())) {
      error = 'המספר שהקלדת לא תקין. מזכירים שצריך את כל 10 הספרות';
      props.setNumberForNuid({error: error});
      return false;
    }
    return true;
  }
  function showContinueButton() {
    let show = false;
    if (props.data.hasSimCard === false && props.data.simCardType === simCardType.sim) {
      show = true;
    } else if (
      props.data.simCardType === simCardType.eSim &&
      ((props.data.selectedTransferOption == transferOption.newLine && props.data.selectedPhoneNumber != '') ||
        props.data.selectedTransferOption == transferOption.niud)
    ) {
      show = true;
    } else if (
      props.data.hasSimCard === true &&
      props.data.simCardNumberAccepted &&
      ((props.data.selectedTransferOption == transferOption.newLine && props.data.selectedPhoneNumber != '') ||
        props.data.selectedTransferOption == transferOption.niud)
    ) {
      show = true;
    }
    return show;
  }

  function getAction() {
    //DWH
    let selectedHetPay = props.portalsBlock.selectedHetPay;
    let simNumber = props.data.hasSimCard === true ? props.data.simCardNumber : '';
    let param7 = props.data.selectedPhoneNumber;
    let param3 = getReportParam();
    const userDetails = props.authentication?.loginData?.userDetails;
    dwhStepOneContinueButtonReport({selectedHetPay, simNumber, param3, param7, userDetails});
    //end DWH

    if (props.data.hasSimCard === true || (props.data.simCardType === simCardType.eSim && deviceSupportsEsimCheckBox())) {
      if (props.data.selectedTransferOption == transferOption.newLine) {
        props.GetOrganizationPricePlan();
        //props.setCurrentStep(TransferAccountStep.PlanSelection);
      } else {
        if (validateNumberForNiud()) {
          props.niudNumberValidation(props.data.numberForNiudForm.value?.trim());
        }
      }
    } else if (props.data.hasSimCard === false && props.data.simCardType === simCardType.sim) {
      if (props.data.simCardCount.error) {
        setError(props.data.simCardCount.error);
      } else {
        props.setCurrentStep(TransferAccountStep.DeliveryPersonalInfo);
      }
    }
  }

  function getReportParam() {
    let param = '';
    if (props.data.hasSimCard === true && props.data.transferOption === transferOption.niud) {
      param = 'סים קיים ניוד';
    } else if (props.data.hasSimCard === true && props.data.selectedTransferOption === transferOption.newLine) {
      param = 'סים קיים קו חדש';
    } else if (props.data.hasSimCard === false && props.data.selectedTransferOption === transferOption.newLine) {
      param = 'eSIM קו חדש';
    } else if (props.data.hasSimCard === false && props.data.selectedTransferOption === transferOption.niud) {
      param = 'eSIM ניוד';
    } else if (props.data.hasSimCard === false && props.data.selectedTransferOption === transferOption.undefined) {
      param = 'הזמנת סים בלבד';
    }
    return param;
  }
  const supportsEsimRef = useRef(null);

  function focusOnSupportsEsim() {
    if (supportsEsimRef.current) {
      const topOffset = supportsEsimRef.current.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({top: topOffset, behavior: 'smooth'});
    }
  }

  return (
    <div className='transfer-line-step'>
      <div className='L_Title'>הפעלת קו חדש</div>
      <div className='has-sim-card-select transfer-line-sub-step'>
        <SelectOptionButton title={'האם יש ברשותכם כרטיס SIM?'} buttonsData={hasSimCardButtons} onClick={(e) => manageHasSimCard(e)} />
      </div>
      {props.data.hasSimCard === true && <SimNumberComponent />}
      {props.data.hasSimCard === false && (
        <div ref={supportsEsimRef}>
          <SelectSimTypeComponent />
        </div>
      )}
      {showBanNumbersList && <SelectBanNumberComponent />}
      {props.data.selectedBanNumber && <SelectTransferLineComponent />}
      {props.data.selectedTransferOption === transferOption.niud && <NiudNumberComponent />}
      {props.data.selectedTransferOption === transferOption.newLine && <SelectPhoneNumber />}
      {props.data.hasSimCard === false && props.data.simCardType === simCardType.sim && <SimCountComponent />}
      {showContinueButton() && (
        <div className='continue-button'>
          {error && <div className='error'>{error}</div>}
          <BtnSubmit
            text={`אפשר להמשיך`}
            onclick={() => {
              getAction();
            }}
          />
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
    portalsBlock: state.portalsBlock,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  resetState,
  setSimCardType,
  setSelectedTransferOption,
  setHasSimCard,
  getOrganizationBanNumbers,
  getPhoneNumbers,
  setCurrentStep,
  getPriceSim,
  setCurrentPopUp,
  setNumberForNuid,
  niudNumberValidation,
  setEpiData,
  setSelectedBanNumber,
  GetOrganizationPricePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferLine);
